// Stripe configuration
// The Stripe Pricing Table uses environment variables directly in the component
// and doesn't require the Stripe.js library to be loaded here.

export const getStripePublishableKey = (): string => {
	const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
	if (!key) {
		throw new Error(
			"VITE_STRIPE_PUBLISHABLE_KEY is not defined in environment variables",
		);
	}
	return key;
};

export const getStripePricingTableId = (): string => {
	const id = import.meta.env.VITE_STRIPE_PRICING_TABLE_ID;
	if (!id) {
		throw new Error(
			"VITE_STRIPE_PRICING_TABLE_ID is not defined in environment variables",
		);
	}
	return id;
};

export const getStripeDashboardUrl = (): string => {
	const url = import.meta.env["VITE_STRIPE_DASHBOARD_URL"];
	if (!url) {
		throw new Error(
			"VITE_STRIPE_DASHBOARD_URL is not defined in environment variables",
		);
	}
	return url;
};
